import '../vendor';

import '../general/ofi';
import '../general/search';
import '../general/hamburger';
import '../general/menu';
import '../general/anchor';
import '../general/warning';
import '../general/up';

import '../pages/universal/universal-audio';
import '../pages/universal/universal-accordion';
import '../pages/universal/universal-info-text';

import '../visually-impaired/open';
import '../visually-impaired/click';
import '../visually-impaired/size';
import '../visually-impaired/color';
import '../visually-impaired/length';
import '../visually-impaired/image';


// WEBPACK FOOTER //
// ./src/js/pages/universal.js